import React from "react";
import { Segment, Button, Icon } from "semantic-ui-react";
import { observer } from "mobx-react-lite";
import { useNavigate } from "react-router-dom";
import BreadcrumbContainer from "../../../app/common/breadcrumb/BreadcrumbContainer";
import ListBroker from "./ListBroker";

interface IProps {
  sections: any[];
}

const DashboardBroker: React.FC<IProps> = ({ sections }) => {
  const navigate = useNavigate();

  document.title = "Agentes comerciales";
  return (
    <div className="configurationContent">
      <BreadcrumbContainer title="Agentes comerciales" sections={sections} />
      <Segment >
        <Button
          onClick={() => navigate(`/home/Configuration/Broker/DashboardNewBroker/${null}`)}
          color="blue"
        >
          <Icon name="add user" /> Nuevo Agente
        </Button>
        <br />
        <br />
        <ListBroker />
      </Segment>
    </div>
  );
};

export default observer(DashboardBroker);
